module.exports = __webpack_public_path__ + "static/certified-expertise-e6863f2b18a6ebd16cebb06f0c9d7d10.png";